module.exports = require("./factory")("g");
